import { render, staticRenderFns } from "./TemplateService.vue?vue&type=template&id=3846c572&scoped=true&"
import script from "./TemplateService.vue?vue&type=script&lang=js&"
export * from "./TemplateService.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3846c572",
  null
  
)

export default component.exports